import { FC, PropsWithChildren } from 'react'

import { ILayout } from '../types/layout.interface'

const Layout: FC<PropsWithChildren<ILayout>> = ({ children, className }) => {
	return (
		<div className='w-full h-full'>
			{/*<Header />*/}
			<div className={className}>{children}</div>
		</div>
	)
}

export default Layout
